import { styled } from '../../Styles/stitches.config'

export const StyledDefaultInput = {
    bgc: '$neutral50',
    border: '1px solid $primary600',
    br: '$1',
    color: '$primary600',
    p: 'calc($3 - ($1 / 2)) $3',
    w: '100%',

    '&::placeholder': {
        color: '$neutral400',
    },

    '&:focus': {
        bc: '$neutral500',
        outline: 'none',
    },

    '&:disabled': {
        bc: '$neutral200',
        bgc: '$neutral50',
        color: '$neutral300',

        '&::placeholder': {
            color: '$neutral300',
        },
    },

    variants: {
        error: {
            true: {
                bc: '$error600',
                bgc: '$error200',
                color: '$error600',

                '&:focus': {
                    bc: '$error600',
                },

                '&::placeholder': {
                    color: '$error600',
                },
            },
        },
    },
}

export const StyledInput = styled('input', {
    ...StyledDefaultInput,
    transition: '$default',

    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        appearance: 'none',
        m: 0,
    },

    '&[type="number"]': {
        appearance: 'textfield',
    },

    '&[type="file"]': {
        p: '0 $3 0 0',

        '&::file-selector-button': {
            bgc: 'transparent',
            border: 'none',
            borderRight: '1px solid $primary600',
            color: '$primary600',
            cursor: 'pointer',
            fontWeight: 600,
            mr: '$3',
            p: 'calc($3 - ($1 / 2)) $3',
            transition: '$default',

            '@canHover': {
                '&:hover': {
                    bc: '$primary500',
                    color: '$primary500',
                },
            },
        },
    },
})
